module.exports = __webpack_public_path__ + "static/media/tool-tip-data.dd4ca5e5.png";